export class ErrorVO {
    code: string;
    message: string;
}